

import React, { useState } from "react";

import { Sidebar } from "primereact/sidebar";

import { teamIds, teamList, userRole } from "../../../src/utils/storage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

const FollowUpsFilter = ({
  visible,
  onHide,
  startDate,
  setStartDate,
 
  endDate,
  setEndDate,
  handleApplyFilter,
  clearFilters,
  startType,
  setStartType,
}) => {

  

  return (
    <Sidebar
      header={
        <div className="flex align-items-center gap-2">
          <span className="font-bold">Filter</span>
        </div>
      }
      visible={visible}
      onHide={onHide}
      position="right"
    >
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-col  gap-5 w-full">
  

 

     

          {/* User */}
          {/* <div className="w-full cursor-pointer relative">
            <select
              className={`appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md py-2 px-3 text-gray-700 ${
                errors.user && "border-red-500"
              }`}
              onChange={(e) => setSelectedUser(e.target.value)}
              value={selectedUser}
              disabled={!selectedTeam || isLoading}
            >
              <option value="">
                {isLoading
                  ? "Loading users..."
                  : !selectedTeam
                  ? "Select a team first"
                  : "Select User"}
              </option>
              {users.map((user, index) => (
                <option key={index} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-customGreen">
              <FaChevronDown />
            </div>
            {errors.user && (
              <p className="text-red-500 text-xs mt-1">{errors.user}</p>
            )}
          </div> */}
     
        {/* Start Date */}
        <div className="relative w-full">
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            placeholderText="Start Date"
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            className="w-full py-2 px-3 pr-52 border-2 border-customGreen rounded-md text-gray-700"
          />
          <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
        </div>

        {/* End Date */}
        <div className="relative w-full m">
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            placeholderText={`${startDate ? "End Date" : "Select Start Date first"} `}
            minDate={startDate}
            disabled={!startDate}
            dateFormat="dd/MM/yyyy"
            className="w-full py-2 px-3 pr-52 border-2 border-customGreen rounded-md text-gray-700"
          />
          <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
        </div>


     <div className="text-customGreen font-medium text-start">Quick Date Filters</div>

     <div className="flex flex-col gap-2">
  {[
    { id: "today", label: "Today", days: 0 },
    { id: "3days", label: "Last 3 Days", days: 3 },
    { id: "7days", label: "Last 7 Days", days: 7 },
    { id: "2weeks", label: "Last 2 Weeks", days: 14 },
    { id: "28days", label: "Last 28 Days", days: 28 },
    { id: "90days", label: "Last 90 Days", days: 90 },
    { id: "thisyear", label: "This Year", isYear: true },
    { id: "lastyear", label: "Last Year", isYear: true },
  ].map(({ id, label, }) => {
    const handleClick = () => {
      setStartType(id);
      const now = new Date();
    
      if (id === "today") {
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        setStartDate(today);
        setEndDate(today);
      } else if (id === "3days") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "7days") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "2weeks") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 13);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "28days") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 27);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "90days") {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 89);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "thisyear") {
        const start = new Date(now.getFullYear(), 0, 1);
        setStartDate(start);
        setEndDate(now);
      } else if (id === "lastyear") {
        const start = new Date(now.getFullYear() - 1, 0, 1);
        const end = new Date(now.getFullYear() - 1, 11, 31);
        setStartDate(start);
        setEndDate(end);
      }
    };
    

    return (
      <div key={id}>
        <input
          type="radio"
          id={id}
          name="dateFilter"
          value={id}
          checked={startType === id}
          onChange={handleClick}
        />
        <label htmlFor={id} className="ml-2">
          {label}
        </label>
      </div>
    );
  })}
</div>

          {/* Buttons */}
          <button
            className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
            onClick={handleApplyFilter}
          >
            Apply Filters
          </button>
          <button
            className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
            onClick={()=>{
              clearFilters()
              setStartType("")
            }}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default FollowUpsFilter;
